import { baseSiteEndPoint, buildHeaders, urlFilters } from "./common";
import { authorizedFetch } from "./login";

export const apiGroupsList = async (filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/user/groups/`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGroupsDetail = async (id) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/user/groups/${id}/`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGroupsCreate = async (data) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/user/groups/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    });
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};

export const apiGroupsUpdate = async (id, data) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/user/groups/${id}/`, {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    });
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};

export const apiGroupsDelete = async (id) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/user/groups/${id}/`, {
      method: "DELETE",
      headers: buildHeaders(),
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const apiGroupsPermissions = async () => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/user/groups/permissions/`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};